"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"
import { trackContactCta } from "@/lib/analytics"

/**
 * The hero's primary button. It scrolls smoothly to the contact section, like the
 * menu's Contact link (the section's `scroll-m-20` keeps it under the sticky header).
 * Without JavaScript the plain `#contact` link still jumps there. When the visitor
 * accepted analytics it sends a `contact_cta` event, with no personal data.
 */
export function ContactCta() {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        trackContactCta()
        const element = document.getElementById("contact")
        if (!element) return
        e.preventDefault()
        element.scrollIntoView({ behavior: "smooth" })
        // Move keyboard focus along with the view; the section is not focusable by default.
        element.setAttribute("tabindex", "-1")
        element.focus({ preventScroll: true })
    }

    return (
        <Button asChild size="lg" variant="brand" className="text-base md:text-lg tracking-normal">
            <a href="#contact" onClick={handleClick}>
                Contact Leanne
            </a>
        </Button>
    )
}
